// src/components/register/RegistrationWizard/Steps/EducationalForms/BachelorsForm.js
import React, { useState, useEffect, useCallback } from "react";
import SearchDropdown from "../../../../Usables/SearchDropdown";
import Dropdown from "../../../../Usables/Dropdown/Dropdown";
import MultiSelectDropdown from "../../../../Usables/MultiSelectDropdown";
import FloatInputField from "../../../../Usables/FloatInputField";
import CollegeList from "../../../../userForms/FormsData/Colleges";
import YearOfStudy from "../../../../userForms/FormsData/Year";
import FutureFields from "../../../../userForms/FormsData/FutureFields";
import OlympiadList from "../../../../userForms/FormsData/Olympiads";
import SchoolBoard from "../../../../options/schoolBoard";
import BachelorsExam from "../../../../userForms/Bachelors/BachelorsExam";
import InternDetails from "../../../../userForms/Bachelors/InternshipDetails";
import RegionsModal from "../../../../Usables/RegionModal";

const BachelorsForm = ({ onChange, data = {} }) => {
  // Form state
  const [errors, setErrors] = useState({});
  const [college, setCollege] = useState(data.college || "");
  const [year, setYear] = useState(data.year || "");
  const [tenthBoard, setTenthBoard] = useState(data.tenthBoard || "");
  const [twelthBoard, setTwelthBoard] = useState(data.twelthBoard || "");
  const [tenthPercentage, setTenthPercentage] = useState(data.tenthPercentage || "");
  const [twelthPercentage, setTwelthPercentage] = useState(data.twelthPercentage || "");
  const [tenthSchoolName, setTenthSchoolName] = useState(data.tenthschoolname || "");
  const [twelthSchoolName, setTwelthSchoolName] = useState(data.twelthschoolname || "");
  const [olympiadpartipated, setOlympiadPartipated] = useState(
    data.olympiadparticipated ? data.olympiadparticipated : []
  );
  const [futurefields, setFutureFields] = useState(
    data.futurefields ? data.futurefields : []
  );
  const [intern, setIntern] = useState(data.intern ? JSON.parse(data.intern) : null);
  const [err, setErr] = useState(null);
  const [err2, setErr2] = useState(null);
  const [exams, setExams] = useState(data.exams ? data.exams : [
    {
      type: "text",
      id: 1,
      name: "",
      date: "",
      percentage: "",
      criteria: "100 %",
    },
  ]);
  const [regions, setRegions] = useState(data.interestedregions ? JSON.parse(data.interestedregions) : [
    {
      id: 1,
      regionName: "Select Region",
      subRegions: [],
      check: false,
    },
  ]);
  const validateField = (field, value) => {
    let error = "";
    if (field === "college" && !value) {
      error = "College name is required";
    } else if (field === "year" && !value) {
      error = "Year of study is required";
    } else if (field === "tenthPercentage" && (isNaN(value) || value < 0 || value > 100)) {
      error = "Please enter a valid number between 0 and 100";
    } else if (field === "twelthPercentage" && (isNaN(value) || value < 0 || value > 100)) {
      error = "Please enter a valid number between 0 and 100";
    }
    setErrors((prev) => ({ ...prev, [field]: error }));
  };

  // Update parent component whenever form data changes
  const memoizedOnChange = useCallback(() => {
    onChange({
      college,
      year,
      tenthBoard,
      twelthBoard,
      tenthPercentage: tenthPercentage,
      twelthPercentage: twelthPercentage,
      tenthschoolname: tenthSchoolName,
      twelthschoolname: twelthSchoolName,
      // olympiadparticipated: JSON.stringify(getValuesArray(olympiadpartipated)),
      // futurefields: JSON.stringify(getValuesArray(futurefields)),
      olympiadparticipated: olympiadpartipated,
      futurefields: futurefields,
      intern: JSON.stringify(intern),
      exams: exams,
      interestedregions: JSON.stringify(regions),
    });
  }, [
    college,
    year,
    tenthBoard,
    twelthBoard,
    tenthPercentage,
    twelthPercentage,
    tenthSchoolName,
    twelthSchoolName,
    olympiadpartipated,
    futurefields,
    intern,
    exams,
    regions,
  ]);

  useEffect(() => {
    memoizedOnChange();
  }, [memoizedOnChange]);

  // Helper function to extract values from multi-select options
  const getValuesArray = (options) => {
    if (!options || options.length === 0) return [];
    return options
      .filter(option => option && option.value !== undefined) // Ensure option is not null/undefined
      .map(option => option.value);
  };

  const handleCollege = (value) => {
    setCollege(value);
    validateField("college", value);
  };

  const handleYear = (e) => {
    setYear(e.value);
    validateField("year", e.value);
  };

  const handleTenthBoard = (e) => {
    setTenthBoard(e.value);
  };

  const handleTwelthBoard = (e) => {
    setTwelthBoard(e.value);
  };

  const handleTenthPercentage = (event) => {
    const value = event.target.value;
    setTenthPercentage(value);
    validateField("tenthPercentage", value);
  };

  const handleTwelthPercentage = (event) => {
    const value = event.target.value;
    setTwelthPercentage(value);
    validateField("twelthPercentage", value);
  };

  const handleTenthSchoolName = (event) => {
    setTenthSchoolName(event.target.value);
  };

  const handleTwelthSchoolName = (event) => {
    setTwelthSchoolName(event.target.value);
  };

  const handleOlympiads = (options) => {
    setOlympiadPartipated(options);
  };

  const handleFutureFields = (options) => {
    setFutureFields(options);
  };

  const handleInternDetails = (internDetails) => {
    setIntern(internDetails);
  };

  const handleRegionsChange = (newRegions) => {
    setRegions(newRegions);
  };

  return (
    <div className="educational-form-content">
      <div className="form-section">
        
        <SearchDropdown
          id="college"
          options={CollegeList}
          onSelect={handleCollege}
          placeholderInput="Search your College"
          placeholderDropdown="College Name"
          selectedValue={college !=="" ? { value: college, label: CollegeList[parseInt(college)-1].label }: null}
        />
        {errors.college && <div className="error-message">{errors.college}</div>}
      </div>
      
      <div className="form-section">
        <Dropdown
          id="year"
          name="currentYear"
          selectedValue={year !== "" ? { value: year, label: YearOfStudy[parseInt(year)-1].label }: null}
          options={YearOfStudy}
          placeHolder="Current Year of Study"
          onChange={handleYear}
        />
        {errors.year && <div className="error-message">{errors.year}</div>}
      </div>
      
      <div className="form-section">
        <Dropdown
          id="tenthBoard"
          name="TenthBoard"
          selectedValue={tenthBoard !== "" ? { value: tenthBoard, label: SchoolBoard[parseInt(tenthBoard)-1].label }: null}
          options={SchoolBoard}
          placeHolder="10th Board"
          onChange={handleTenthBoard}
        />
      </div>

      <div className="form-section">
        <FloatInputField
          id="tenthPercentage"
          name="TenthPercentage"
          placeHolder="10th Percentage"
          handleInput={handleTenthPercentage}
          err={errors.tenthPercentage}
          inputVal={tenthPercentage}
        />
        {errors.tenthPercentage && <div className="error-message">{errors.tenthPercentage}</div>}
      </div>
      
      <div className="form-section">
        <Dropdown
          name="TwelthBoard"
          selectedValue={twelthBoard !== "" ? { value: twelthBoard, label: SchoolBoard[parseInt(twelthBoard)-1].label } : null}
          options={SchoolBoard}
          placeHolder="12th Board"
          onChange={handleTwelthBoard}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TwelthPercentage"
          placeHolder="12th Percentage"
          handleInput={handleTwelthPercentage}
          err={err2}
          inputVal={twelthPercentage}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="TenthSchoolName"
          placeHolder="10th School Name"
          handleInput={handleTenthSchoolName}
          inputVal={tenthSchoolName}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="SchoolName"
          placeHolder="12th School Name"
          handleInput={handleTwelthSchoolName}
          inputVal={twelthSchoolName}
        />
      </div>
      
      <div className="form-section exams-section">
        <BachelorsExam exams={exams} setExams={setExams} />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={FutureFields}
          onSelect={handleFutureFields}
          selectedValues={futurefields}
          placeholderDropdown="Interested fields in Future"
          placeholderInput="Search for interested fields"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={OlympiadList}
          onSelect={handleOlympiads}
          selectedValues={olympiadpartipated}
          placeholderDropdown="Olympiads participated"
          placeholderInput="Search olympiads"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <InternDetails onInternDetails={handleInternDetails} initialData={intern} />
      </div>
      
      <div className="form-section">
        <RegionsModal
          regions={regions}
          setRegions={handleRegionsChange}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      </div>
    </div>
  );
};

export default BachelorsForm;